// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__1DUbI","tab":"ProcedureTabs_tab__2NkfX"};